import CustomCell from 'src/components/Table/CustomCell';
import { sortingMethods } from 'src/constants/table';

// Widths are weights shared out among whichever columns are showing, so hiding one widens the rest.
export const DEVICE_UNMATCHED_FILES_COLUMNS = [
  {
    key: 'fileName',
    label: 'File Name',
    sortable: true,
    sortKey: 'fileName',
    weight: 4.6,
    required: true,
  },
  { key: 'authenticodeHash', label: 'Authenticode Hash', weight: 3.6 },
  {
    key: 'lastSeen',
    label: 'Last Seen',
    sortable: true,
    sortKey: 'lastSeen',
    weight: 1.8,
  },
  {
    key: 'last30Count',
    label: 'Last 30 Count',
    sortable: true,
    sortKey: 'last30Count',
    weight: 1.8,
  },
  {
    key: 'last90Count',
    label: 'Last 90 Count',
    sortable: true,
    sortKey: 'last90Count',
    weight: 1.8,
  },
];

export const DEFAULT_VISIBLE_DEVICE_UNMATCHED_FILES_COLUMNS = DEVICE_UNMATCHED_FILES_COLUMNS.filter(
  column => column.key !== 'authenticodeHash',
).map(column => column.key);

export const columnsOrder = [
  { name: 'processName', styles: { wordBreak: 'break-word' } },
  { name: 'fullFilePath', styles: { wordBreak: 'break-word' } },
  { name: 'deviceWdacEventsCount', isNumeric: true },
  {
    name: 'eventSystemTime',
    styles: { minWidth: '70px' },
  },
];

export const headings = [
  {
    title: 'Process Name',
    name: 'processName',
    hasSorting: false,
    width: '35%',
  },
  {
    title: 'File Name',
    name: 'fullFilePath',
    hasSorting: false,
    width: '35%',
  },
  {
    title: 'WDAC Events Count',
    name: 'deviceWdacEventsCount',
    hasSorting: false,
    width: '15%',
  },
  {
    title: 'Date',
    name: 'eventSystemTime',
    hasSorting: false,
    width: '15%',
  },
];

export const MAIN_TABLE_HEADERS = [
  { title: 'File Name', name: 'filePath', width: '26%' },
  { title: 'SHA-256 Hash', name: 'sha256', width: '40%' },
  {
    title: 'Event System Time',
    name: 'eventSystemTime',
    hasSorting: true,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterUnmatchedFiles',
    sortingCellField: 'event_system_time',
    sortFieldName: 'OrderWdacQuery',
    width: '18%',
  },
  {
    title: 'Count',
    name: 'count',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterUnmatchedFiles',
    sortingCellField: 'wdac_items_total_count',
    sortFieldName: 'OrderWdacQuery',
    width: '8%',
  },
  { title: '', name: 'actions', width: '8%' },
];
